








































































































































































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import ModalBox from '../../components/ModalBox.vue';
import moment from 'moment';
import { Debounced } from '../../utils/debounced';
@Component({
  components: {
    Loading,
    ModalBox,
  },
})
export default class Tracking extends Vue {
  private user: any;
  private moment: any = moment;
  private modalTitle: string = '详情';
  private spinning = false;
  private dateFormat: string = 'YYYY-MM-DD';
  private selectBeforeTime: any = this.moment(new Date()).add(-21, 'days');
  private selectAfterTime: any = this.moment(new Date());
  private searchPM: string = '家伟';
  private searchserviceprovider: string = 'ALL';
  private searchAsin: string = '';
  private store: string = 'ALL';
  private storeArr: any = [{
    store: 'ALL',
  }, {
    store: 'US',
  }, {
    store: 'CA',
  }, {
    store: 'UK',
  }];
  private that = this;
  private dataJson: any = [];
  private selectDataJson: any = [];
  private searchProductNameAsinJson: any = [];
  private searchProductName: string = '';
  private searchProductAsin: string = '';
  private disabledAsin: boolean = true;
  private last: number = 0;
  private goodsData: any = {};
  private arrangeGoodsData: any = {};
  private debouncedUse: (...args: any[]) => any =  new Debounced().use(this.pullDataSource, 1000);
  private dataSource: any = [];
  private allPrice: number = 0;
  private trackingType: string = 'ALL';
  private modalJson: any = {
    id: '',
    productNumber: '',
    pmName: '',
    productName: '',
    asin: '',
    store: '',
    shipMentID: '',
    brand: '',
    account: '',
    service_provider: '',
    trackPrice: 0,
    FNSKU: '',
    number: 0,
    remarks: '',
    trackingNumber: '',
    trackingTime:  moment(new Date()),
    trackingDetails: '',
    server_provider: '',
  };
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.getData();
      this.getSelectData();
      let trackingPM = '菊新';
      if (storage.get('trackingPM')) {
        trackingPM = storage.get('trackingPM');
        this.searchPM = trackingPM;
      }
      this.handleChange(trackingPM, 'pmName', 'empty');
      if (this.$router.currentRoute.query && this.$router.currentRoute.query.from) {
        const goodsData = this.$store.state.goodsInfo;
        const boo1 = (JSON.stringify(goodsData) === '{}');
        const arrangeGoodsData = this.$store.state.arrangeGoodsInfo;
        const boo2 = (JSON.stringify(arrangeGoodsData) === '{}');
        const type = this.$router.currentRoute.query.from;
        if (type === 'GoodsList' && !boo1) {
          // 如果是从 goodsList 跳转过来
          this.goodsData = goodsData;
          this.modalFun(false, '创建', {}, -1, 'GoodsList');
        } else if (type === 'ArrangeGoodsList' && !boo2) {
          // 如果是从 goodsList 跳转过来
          this.arrangeGoodsData = arrangeGoodsData;
          this.modalFun(false, '创建', {}, -1, 'ArrangeGoodsList');
        }
      }
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private async pullDataSource(searchText: string) {
    const data: any = await this.getDataSource(searchText);
    const arr: any = [];
    if (data.length > 0) {
      data.forEach((element: any, index: number) => {
        arr.push(element.productName);
      });
      this.dataSource = arr;
    }
  }
  private getDataSource(Keyword: string) {
    return new Promise((resolve, reject) => {
      this.spinning = true;
      const that = this;
      const url = '/api/getPmInfoLike';
      const args = {
        pmName: this.searchPM,
        Keyword,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          resolve(res.data.data);
          // that.dataSource = res.data.data;
          this.spinning = false;
        }
      });
    });
  }
  private async onSearch(searchText: string) {
    this.debouncedUse(searchText);
  }
  // private ePP() {
  //  this.$router.push({
  //     path: '/EditorPMProduct',
  //   });
  // }
  private changeSearchAsin(event: any) {
    const that = this;
    that.last = event.timeStamp;
    setTimeout(() => {
      if (that.last - event.timeStamp === 0) {
        // 你的逻辑
        const url = '/api/getPMProductInfo';
        const args = {
          asin: this.searchAsin,
          team: this.user.team,
        };
        that.axios.post(url, args).then((res) => {
          if (res.data.data.length > 0) {
            // that.$set(, '');
            const name = res.data.data[0].pmName;
            that.searchPM = name;
            that.searchProductName = res.data.data[0].productName;
            that.handleChange(name, 'pmName', 'asin');
          } else {
            that.$message.error('暂无此asin数据!!!');
            // that.modalDisabled = false;
          }
        });
      }
    }, 900);
  }
  private onPickerChange(date: any, dateString: string) {
    // console.log(date, dateString);
    this.selectBeforeTime = date[0];
    this.selectAfterTime = date[1];
  }
  private async handleChange(value: string, type: string, asinType: string) {
    // asinType  1 empty  2 asin
    const that = this;
    if ( type === 'pmName' ) {
      storage.set('trackingPM', value);
      that.dataSource.splice(0, that.dataSource.length);
      const url = '/api/getPMTrackingProAsin';
      const args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          if (asinType === 'empty') {
            that.searchProductNameAsinJson = res.data.data[0];
            that.searchProductNameAsinJson.unshift({
              productName: 'ALL',
              asin: '',
            });
            that.searchProductName = '';
            that.searchAsin = '';
          } else if ( asinType === 'asin' ) {
            that.searchProductNameAsinJson = res.data.data[0];
            that.searchProductNameAsinJson.unshift({
              productName: 'ALL',
              asin: '',
            });
          }
        }
      });
    } else if ( type === 'productName' ) {
      const args = {
        productName: value,
      };
      await this.getTrackingAll(args);
      this.searchProductNameAsinJson.forEach( (element: any) => {
        if (element.productName === value) {
          this.searchAsin = element.asin;
        }
      });
    }
  }
  private getTrackingAll(args: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      // 根据 productNumber 自动填写 其他确认的数据;
      const url = '/api/getTrackingAll';
      this.axios.post(url, args).then((res) => {
        const data = res.data.data[0];
        that.searchProductName = data.productName;  // 产品名称
        that.searchPM  = data.pmName; // PM
        that.searchAsin  = data.asin; // asin
        resolve();
      });
    });
  }
  private async getSelectData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getSelectTracking';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      that.selectDataJson = res.data.data;
      that.spinning = false;
    });
  }
  private async getData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getTracking';
    const args = {
      pmName: this.searchPM,
      asin: this.searchAsin,
      trackingType: this.trackingType,
      service_provider: this.searchserviceprovider,
      store: this.store,
      date: [
        this.moment(this.selectBeforeTime).format(this.dateFormat),
        this.moment(this.selectAfterTime).format(this.dateFormat),
      ],
    };
    const data = await this.axios.post(url, args);
    if ( data === undefined ) {
      this.spinning = false;
      this.dataJson = [];
    } else {
      this.allPrice = data.data.data.allPrice;
      if (data.data) {
        this.dataJson = data.data.data.data;
      } else {
        this.dataJson = [];
      }
      this.spinning = false;
    }
  }
  private changeDataJson(type: string , obj: any, index: number) {
    // this.dataJson.splice(index, 1, obj);
    this.getData();
  }
  private modalFun(boo: boolean, titleStatus: string, data: any, index: number, from: string) {
    this.modalTitle = titleStatus;
    if (titleStatus === '创建') {
      this.modalJson = {
        id: 0,
        productNumber: '',
        pmName: '',
        productName: '',
        asin: '',
        store: '',
        shipMentID: '',
        brand: '',
        account: '',
        service_provider: '',
        trackPrice: 0,
        number: 0,
        FNSKU: '',
        remarks: '',
        trackingType: '',
        trackingNumber: '',
        trackingTime: moment(new Date()),
        trackingDetails: '',
        server_provider: '',
      };
    } else {
      this.modalJson = data;
    }
    if (from === 'GoodsList') {
      // 如果是从 goodsList 跳转过来
      (this.$refs.modalBoxRef as any).showModalFromGoods(boo, index, 'GoodsList');
    } else if (from === 'ArrangeGoodsList') {
      (this.$refs.modalBoxRef as any).showModalFromArrangeGoods(boo, index, 'ArrangeGoodsList');
    } else {
      // 调用组件的方法;
      (this.$refs.modalBoxRef as any).showModal(boo, index, '');
    }
  }
  private showDeleteConfirm(type: string, data: any, index: number) {
    const that = this;
    if (type === 'delete') {
      this.$confirm({
        title: '确定要删除?',
        content: '',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          // that.dataJson.splice(index, 1);
          const url = '/api/getDeleteTracking';
          const args = data;
          that.axios.post(url, args).then((res: any) => {
            //
            that.getData();
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else if (type === 'close') {
      this.$confirm({
        title: '确定要关闭?',
        content: '',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          // 向服务器  更改 closeStatus 的状态  默认为0 更改为1    1代表完成跟踪
          const url = '/api/getCloseTracking';
          const args = data;
          that.axios.post(url, args).then((res: any) => {
            //
            that.getData();
          });
          // 在原数组中删除
          // that.dataJson.splice(index, 1);
        },
        onCancel() {
          console.log('Cancel');
        },
      });

    }

  }

}
